import React from 'react';
import {ButtonGroup, Button} from 'forms';
import t from '@rcm/i18n-client';
import noop from 'lodash/noop';
import CrudHub from '../CrudHub';

interface Props {
    disabled?: boolean;
    onNew?: () => void;
    onRevertAll?: () => void;
    onReview?: () => void;
    totalEdits?: number;
}

const CrudFooter = ({
    disabled = false,
    totalEdits = 0,
    onRevertAll = noop,
    onNew = noop,
    onReview = noop,
}: Props) => <CrudHub.Foot.Send className="crud-footer">
    <ButtonGroup className="pull-left">
        <Button btn="default"
            disabled={disabled || !totalEdits}
            icon="refresh"
            text={t('Revert All')}
            onClick={onRevertAll}
        />
        <Button
            disabled={disabled}
            btn="success"
            text={t('Create New')}
            icon="plus"
            onClick={onNew}
        />
    </ButtonGroup>
    <Button btn="primary"
        className="pull-right"
        onClick={onReview}
        disabled={disabled || !totalEdits}
        icon="floppy-save"
        text={
            totalEdits === 0 ?
                t('No Changes') :
            totalEdits === 1 ?
                t('Review and Save 1 Change') :
            t(
                'Review and Save {totalEdits} Changes',
                {totalEdits}
            )
        }
    />
</CrudHub.Foot.Send>;

export default CrudFooter;
